module.exports = __webpack_public_path__ + "img/mediaworks-banner.6a8af286.jpg";